import {requestInstance} from "@/app/[locale]/config/requestInstance";
import CountryModel from "@/app/services/models/CountryModel";

class CountryService {
    api = {
        main: '/countries'
    }

    params = {
        search: "search=",
    };

    getAll(query) {
        const queryParam = query?.length > 0 ? `?${this.params.search}${query}` : '';
        return requestInstance.get(`${this.api.main}${queryParam}`)
            .then(r => r?.data.map(item => new CountryModel(item)))
            .catch(err => Promise.reject(err))
    }
}

export const countryService = new CountryService();